import React from "react";
import { r } from "../utils";
import { withState } from "recompose";
import {
  HideDesktop,
  HideTablet,
  HideMobile,
  ShowMobile
} from "./blocks/Responsive";
import Waypoint from "react-waypoint";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { getFontFamily } from "../utils";
import { P, H4, Description } from "./typography";
import Frame1 from "../../assets/animation/vasano_frame1.gif";
import Frame2 from "../../assets/animation/vasano_frame2.gif";
import Frame3 from "../../assets/animation/vasano_frame3.gif";
import Frame4 from "../../assets/animation/vasano_frame4.gif";
import Flex from "../components/blocks/Flex";
import Spacer from "../components/blocks/Spacer";

const Title = H4.extend`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  padding-top: 3rem;
  max-width: 100%;
`;

const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: wrap;
  max-width: 1200px;
  padding: 2rem;
`;

const AnimationText = styled.div`
  padding: 3rem 2rem 3rem 1rem;
  flex: 2;
  ${props => props.theme.media.desktop`
padding: 1rem 2rem 3rem 1rem;
`};
`;

const AnimationSVG = styled.div`
  flex: 2;
  width: 100%;
`;

export default ({ animationTitles = [""], animationDescriptions = [""] }) =>
  <Grid>
    <AnimationContainer>
      <AnimationSVG>
        {" "}<Image style={{ paddingTop: "0px" }} src={Frame1} />{" "}
      </AnimationSVG>
      <AnimationText>
        <Title>
          {" "}{animationTitles[0]}{" "}
        </Title>
        <Description>
          {" "}{animationDescriptions[0]}{" "}
        </Description>
      </AnimationText>
      <AnimationSVG>
        {" "}<Image src={Frame2} />{" "}
      </AnimationSVG>
      <AnimationText>
        <Title>
          {" "}{animationTitles[1]}{" "}
        </Title>
        <Description>
          {" "}{animationDescriptions[1]}{" "}
        </Description>
      </AnimationText>
      <AnimationSVG>
        {" "}<Image src={Frame3} />{" "}
      </AnimationSVG>
      <AnimationText>
        <Title>
          {" "}{animationTitles[2]}{" "}
        </Title>
        <Description>
          {" "}{animationDescriptions[2]}{" "}
        </Description>
      </AnimationText>
    </AnimationContainer>
  </Grid>;



// WEBPACK FOOTER //
// ./src/components/ProductAnimationMobile.js